export class PutUserSettingsResponse {
}
